import { useFeatureFlag } from '@artic/ui/feature-flags';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { parseAsString, useQueryState } from 'nuqs';
import { useState } from 'react';

import { usePartnerId } from '../../../features/inbox/use-partner-name';
import { runSheetsMatrixQueryOptions } from '../../../features/run-sheets/queries';
import { RelevanceRulesList } from '../../../features/run-sheets/relevance-rules-list';
import { RuleEditorDialog } from '../../../features/run-sheets/rule-editor-dialog';

export const Route = createFileRoute('/run_sheets/rules/')({
  staticData: {
    breadcrumb: 'Rules',
    layout: 'full-height',
  },
  component: RelevanceRulesPage,
});

function RelevanceRulesPage() {
  const plannerEnabled = useFeatureFlag('planner');

  if (!plannerEnabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature Not Available</h2>
        <p className="text-muted-foreground text-sm">
          The Rules editor is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <RelevanceRulesContent />;
}

function RelevanceRulesContent() {
  const partnerId = usePartnerId();

  // Set when the page is opened from a project's Run Sheets grid (ENG-760), so
  // "Back to Run Sheet Grid" returns there instead of the partner catalogue.
  const [projectId] = useQueryState('projectId', parseAsString);

  const [ruleEditorOpen, setRuleEditorOpen] = useState(false);

  // Only `matrix.operations` is read here (the rule editor's dropdown), so this
  // does not opt into the release-progress refetch.
  const { data: matrix } = useQuery(runSheetsMatrixQueryOptions(partnerId));

  return (
    <>
      <RelevanceRulesList
        partnerId={partnerId}
        projectId={projectId}
        onOpenRuleEditor={() => {
          setRuleEditorOpen(true);
        }}
      />
      {ruleEditorOpen && (
        <RuleEditorDialog
          open={ruleEditorOpen}
          onOpenChange={setRuleEditorOpen}
          partnerId={partnerId}
          operations={matrix?.operations ?? []}
        />
      )}
    </>
  );
}
